var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 22L2.25039 14.55L13.6004 3.19995L19.2004 8.79996L7.85039 20.1499L0.400391 22ZM3.55039 15.25L2.35039 20.05L7.15039 18.85L17.2504 8.74995L13.6504 5.14995L3.55039 15.25Z",
    fill: "#1D428A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6502 19.6998C6.1502 17.7498 4.6502 16.2498 2.7002 15.7498L3.0502 14.3499C5.5002 14.9499 7.4002 16.8499 8.0002 19.2999L6.6502 19.6998Z",
    fill: "#1D428A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16.95L5.5 15.8999L15.45 5.94995L16.45 6.94995L6.5 16.95Z",
    fill: "#1D428A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40039 20.9998L3.60039 20.4498C3.40039 19.6498 2.75039 18.9998 1.95039 18.7998L1.40039 20.9998Z",
    fill: "#1D428A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7504 8.24991L14.1504 2.6499L16.4004 0.399902L16.7504 0.449905C19.4504 0.799905 21.6004 2.9499 21.9504 5.6499L22.0004 5.99991L19.7504 8.24991ZM16.2004 2.6499L19.8004 6.24991L20.5004 5.54991C20.1004 3.74991 18.7004 2.34991 16.9004 1.94991L16.2004 2.6499Z",
    fill: "#1D428A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/Icon_Pencil.8754dc173f425bdf7f48fd88c5632cc1.svg";
export { ForwardRef as ReactComponent };